import React, { AllHTMLAttributes, FC, ReactNode, useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { cn, resultIf, RouteDictionary } from '../../../utils';
import { ChevronIcon, CustomLink, Dropdown } from '../../common';
import { DropdownContext } from '../../common/generics/Dropdown/composables/DropdownContext';

import './NavigationDropdown.scoped.scss';

type RouteMapObject = {
  text: string;
  route: RouteDictionary;
};

export type RouteMap = {
  [key: string]: RouteMapObject;
};

export interface NavigationDropdownProps extends AllHTMLAttributes<HTMLDivElement> {
  routesMap: RouteMap;
  placeholderText: ReactNode;
}

const NavigationDropdown: FC<NavigationDropdownProps> = ({
  routesMap,
  placeholderText,
  ...props
}) => {
  const { pathname } = useLocation();
  const { toggle } = useContext(DropdownContext);
  const renderHead = () => {
    const element = routesMap[pathname];
    return element === undefined ? placeholderText : element.text;
  };
  const renderLinks = () => {
    return Object.entries(routesMap).map((entry) => {
      return (
        <li key={entry[1].text} className="navigation-dropdown__element">
          <CustomLink to={entry[1].route} className="navigation-dropdown__link" onClick={toggle}>
            {entry[1].text}
          </CustomLink>
        </li>
      );
    });
  };
  return (
    <Dropdown className={cn('navigation-dropdown', props.className)}>
      <Dropdown.Head className="navigation-dropdown__head">
        <DropdownContext.Consumer>
          {({ active }) => (
            <>
              <div className="navigation-dropdown__active">{renderHead()}</div>
              <ChevronIcon
                direction="up"
                size={16}
                color="#111"
                className={cn('navigation-dropdown__image', resultIf(active, 'active'))}
                title="Раскрыть меню"
              />
            </>
          )}
        </DropdownContext.Consumer>
      </Dropdown.Head>
      <Dropdown.Content className="navigation-dropdown__content">
        <ul className="navigation-dropdown__list">{renderLinks()}</ul>
      </Dropdown.Content>
    </Dropdown>
  );
};

export default NavigationDropdown;
